import { Components } from '@mui/material/styles';

const muiAccordionStyles: Components = {
  MuiAccordion: {
    styleOverrides: {
      root: {
        border: 'none',
        padding: '8px 8px',
        borderBottom: '1px solid var(--gray-6)',
        boxShadow: 'none',
        '&:before': {
          display: 'none'
        },
        '&.Mui-expanded': {
          margin: 0
        },
        '&.bordered-accordion': {
          border: '1px solid var(--gray-9)',
          borderBottom: '1px solid var(--gray-9)',
          borderRadius: '14px',
          backgroundColor: 'var(--white)',
          '&:before': { display: 'none' }
        }
      }
    }
  },
  MuiAccordionSummary: {
    styleOverrides: {
      root: {
        padding: 0,
        minHeight: 'auto',
        '&.Mui-expanded': {
          minHeight: 'auto'
        },
        '& .MuiAccordionSummary-content': {
          margin: 0,
          padding: '0px',

          '&.Mui-expanded': {
            margin: 0
          }
        },
        '.bordered-accordion &': {
          padding: '0 12px',
          minHeight: '40px',
          '&.Mui-expanded': {
            minHeight: '40px'
          },
          '& .MuiAccordionSummary-content': {
            margin: 0
          }
        }
      },
      content: {
        '&.Mui-expanded': {
          color: 'var(--red-1)'
        }
      }
    }
  },
  MuiAccordionDetails: {
    styleOverrides: {
      root: {
        padding: 0,
        '.bordered-accordion &': {
          padding: '8px 12px 16px'
        }
      }
    }
  }
};

export default muiAccordionStyles;
